import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { MyIcon } from "../../common/baseConfig";
import { Form, Radio, Input, Upload, Button, Icon, AutoComplete, message } from "antd";
const AutoCompleteOption = AutoComplete.Option;

export class Feedback extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props)
    this.state = {
      autoCompleteResult: [],
      loading: false,
      txtAreaLength: 0,
      notUpload: false,
      fileList: [],
      flagImgs: []
    }
  }
  onChangeFeedBackType(typeId) {
    this.setState({
      typeId
    })
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let { fileList } = this.state;
        fileList = fileList.filter((file) => {
          if (file.response) {
            return file.response.SuccessResponse === true;
          }
          return false;
        });
        values.ImgURL = "";

        fileList.forEach(item => {
          values.ImgURL += `${item.response.Message};`
        })
        this.setState({
          loading: true
        })
        this.props.actions.fetchFeedback(values).then((res) => {
          if (res.SuccessResponse) {
            message.success(res.Message);
            this.props.history.goBack();
          }
          this.setState({
            loading: false
          })
        })
      }
    });
  }
  handleWebsiteChange = (value) => {
    let autoCompleteResult;
    if (!value) {
      autoCompleteResult = [];
    } else {
      autoCompleteResult = ['.com', '.org', '.net'].map(domain => `http://${value}${domain}`);
    }
    this.setState({ autoCompleteResult });
  }
  onFilesLimit(file) {
    let size = (file.size / 1024).toFixed(2);
    let type = file.type.slice(file.type.indexOf('/') + 1, file.type.length);
    const isLt500 = size <= 500;
    const isJPG = type === "jpg";
    const isJPEG = type === "jpeg";
    const isPNG = type === "png";
    if (!isLt500) {
      message.error('上传图片大小不能超过500KB', 2);

    }
    if (!isJPG && !isPNG && !isJPEG) {
      message.error('请上传正确的可支持图片格式', 2);
    }
    return isLt500 && (isJPG || isPNG || isJPEG);
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    let { autoCompleteResult, fileList, flagImgs } = this.state;
    const formItemLayout = {
      labelCol: { span: 2 },
      wrapperCol: { span: 20, },
    };
    const websiteOptions = autoCompleteResult.map(website => (
      <AutoCompleteOption key={website}>{website}</AutoCompleteOption>
    ));
    const Uploadrops = {
      action: '/service/public/Upload/File/2',
      listType: 'picture',
      className: 'upload-list-inline',
      directory: false,
      multiple: true,
      showUploadList: false,
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
      beforeUpload: (file) => {

        return this.onFilesLimit(file);
      },
      onChange: (file) => {

        for (let i = 0; i < file.fileList.length; i++) {
          const item = file.fileList[i];
          if (item.status && item.status === "done" && file.file.name === item.name && this.state.flagImgs.indexOf(item.name) === -1) {
            this.setState({
              fileList: this.state.fileList.concat(item),
              flagImgs: this.state.flagImgs.concat(item.name),
            }, () => {

              if (this.state.fileList.length >= 5) {
                this.setState({
                  notUpload: true,
                })
              }
            })
          }
        }
      }
    };
    return (
      <div className="center-feedback">
        <div className="feedback_header">
          <img src={require('../../images/feedback_banner.png')} alt="" />
          <div className="feedback_header_text">
            <h3>意见反馈</h3>
            <p>欢迎提出任何疑问与建议，您的意见我们非常重视！</p>
          </div>
        </div>
        <div className="feedback_content_wrap">
          <div className="feedback_content">
            <div className='fb_view'>
              <Form {...formItemLayout} onSubmit={this.handleSubmit.bind(this)} className='fb_form'>
                <Form.Item
                  label="反馈类型"
                >
                  {getFieldDecorator('Type', {
                    rules: [{ required: true, message: "请选择反馈类型" }],
                  })(
                    <Radio.Group>
                      <Radio.Button value="0">内容意见</Radio.Button>
                      <Radio.Button value="1">产品建议</Radio.Button>
                      <Radio.Button value="2">技术问题</Radio.Button>
                      <Radio.Button value="3">其他建议</Radio.Button>
                    </Radio.Group>
                  )}
                </Form.Item>
                <Form.Item
                  label="详细描述"
                >
                  {getFieldDecorator('Content', {
                    rules: [{ required: true, message: "请输入详细描述" }, {
                      max: 500, message: "输入字符不能超过500字符长度",
                    }],
                  })(
                    <div className='txtArea' name={`${this.state.txtAreaLength}/500`}>
                      <Input.TextArea placeholder="请尽量详细的描述您的问题，有助于我们快速给到您反馈" onChange={e => {
                        this.setState({
                          txtAreaLength: e.target.value.length,
                        })
                      }} />
                    </div>
                  )}
                </Form.Item>
                <Form.Item
                  wrapperCol={{ span: 12, push: 2 }}
                >
                  {getFieldDecorator('ImgURL', {
                  })(
                    <Upload {...Uploadrops}>
                      <Button disabled={this.state.notUpload}>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <Icon type="picture" /><span style={{ marginLeft: 5, marginTop: -3 }}>上传图片</span>
                        </div>
                      </Button>
                      <span className='upload_tip'>最多可上传5张图片；大小不超过500KB；图片格式支持‘jpg’,‘png’</span>
                    </Upload>
                  )}
                </Form.Item>
                <Form.Item
                  wrapperCol={{ span: 12, push: 2 }}
                >
                  <div className="files-view">
                    {
                      fileList.map((item, index) => (
                        <div className="files-view-item" key={index}>
                          <img src={item.response.Message} alt="" />
                          <span className="del-icon" onClick={() => {
                            fileList.splice(index, 1);
                            flagImgs.splice(index, 1);
                            this.setState({
                              fileList, flagImgs,
                              notUpload: fileList.length > 5
                            })
                          }}>
                            <MyIcon type="iconshanchu" />
                          </span>
                        </div>
                      ))
                    }

                  </div>
                </Form.Item>
                <Form.Item label="页面网址">
                  {getFieldDecorator('AboutPage', {
                    rules: [{ required: true, message: '请输入页面网址' }],
                  })(
                    <AutoComplete
                      dataSource={websiteOptions}
                      onChange={this.handleWebsiteChange}
                    >
                      <Input />
                    </AutoComplete>
                  )}
                </Form.Item>
                <Form.Item label="联系方式">
                  {getFieldDecorator('Concactway', {
                    rules: [{ required: true, message: '请输入您的联系方式' }],
                  })(
                    <Input placeholder="请输入您的 手机号/QQ/邮箱，以便我们能及时给您反馈" />
                  )}
                </Form.Item>
                <Form.Item wrapperCol={{ span: 3, push: 19 }}>
                  <Button className='subBtn' htmlType="submit" loading={this.state.loading}>提交</Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {

  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

const WrappedFeedBackForm = Form.create({ name: "feed_back" })(Feedback);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedFeedBackForm);



// WEBPACK FOOTER //
// ./src/features/common/FeedBack.js